import React from 'react';
import PropTypes from 'prop-types';

export const SizeQuizExampleButton = ({ className, message }) => {
  return (
    <button
      className={className}
      onClick={() => {
        document.getElementById("fittersAdvice").scrollIntoView({ behavior: "smooth"});
      }}
    >
      {message}
    </button>
  );
};

export const SizeQuizButton = ({
  selected,
  setSelected,
  partTwoSelected,
  setPartTwoSelected,
  text,
  id,
  customFunc,
}) => {
  let selectedId = selected;
  if (partTwoSelected !== undefined) {
    selectedId = partTwoSelected;
  }
  return (
    <div className="buttons">
      <button
        className={selectedId === id ? 'selected' : 'unselected'}
        onClick={() => {
          if (setPartTwoSelected) {
            setPartTwoSelected(id);
          } else {
            setSelected(id);
          }
          if (customFunc) {
            customFunc();
          }
        }}
      >
        {text}
      </button>
    </div>
  );
};

SizeQuizButton.propTypes = {
  selected: PropTypes.number,
  setSelected: PropTypes.func,
  partTwoSelected: PropTypes.number,
  setPartTwoSelected: PropTypes.func,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.number,
  customFunc: PropTypes.func,
};

SizeQuizExampleButton.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
};
